// extracted by mini-css-extract-plugin
module.exports = {"main":"articleBody_main__1anUN","articlecontent":"articleBody_articlecontent__3Wy-5"};